export const PlatformList = [
  {
    label: 'Site (Visão Cliente)',
    value: '1',
  },
  {
    label: 'Extranet (Visão Parceiro)',
    value: '2',
  },
  {
    label: 'Site e Extranet (Ambas)',
    value: '3',
  },
];

export const DestinationTypes = [
  {
    label: 'Parceiro',
    value: '1',
  },
  {
    label: 'Assessor',
    value: '2',
  },
  {
    label: 'Cliente',
    value: '3',
  },
];
